import { randomBytes } from 'crypto';
import * as BIP39 from 'bip39';

var HDKey = require('hdkey');

export var mnemonic;

(function (mnemonic) {
  // see https://github.com/satoshilabs/slips/blob/master/slip-0044.md
  var VET_DERIVATION_PATH = "m/44'/818'/0'/0";
  /** generate BIP39 mnemonic words */

  function generate() {
    return BIP39.generateMnemonic(128, randomBytes).split(' ');
  }

  mnemonic.generate = generate;
  /**
   * check if the given mnemonic words have valid checksum
   * @param words mnemonic words
   */

  function validate(words) {
    return BIP39.validateMnemonic(words.join(' '));
  }

  mnemonic.validate = validate;
  /**
   * derive private key from mnemonic words according to BIP32.
   * the derivation path is defined at https://github.com/satoshilabs/slips/blob/master/slip-0044.md
   */

  function derivePrivateKey(words) {
    var seed = BIP39.mnemonicToSeed(words.join(' '));
    var hdKey = HDKey.fromMasterSeed(seed);
    return hdKey.derive(VET_DERIVATION_PATH + '/0').privateKey;
  }

  mnemonic.derivePrivateKey = derivePrivateKey;
})(mnemonic || (mnemonic = {}));